<h2 mat-dialog-title i18n="Share post dialog|title @@sharePostDialog.title">Открыть доступ к посту по ссылке</h2>
<mat-dialog-content>
  @if (loading) {
    <tg-inline-loader></tg-inline-loader>
  }
  @if (!loading && !data.post.shareCode) {
    <p i18n="Share post dialog|desc @@sharePostDialog.desc">
    По ссылке будет доступна возможность просматривать пост и делать его копию.
  </p>
  }
  @if (data.post.shareCode) {
    <div>
      <div fxLayout="column" style="min-width: 300px">
        <label for="link" i18n="Share post dialog|label @@sharePostDialog.linkLabel">Ссылка на пост:</label>
        <div fxLayout="row">
          <input
            #link
            id="link"
            class="custom-input"
            type="text"
            value="{{ 'https://app.telepost.me/sp/' + data.post.id + '/' + data.post.shareCode }}"
            readonly
            (click)="handleClickInput($event)"
            />
          <div fxFlex fxFlexAlign="center">
            <button
              mat-icon-button
              color="primary"
              class="copy-btn"
              matTooltip="скопировать ссылку"
              i18n-matTooltip="Share post dialog|button @@sharePostDialog.copyLinkButton"
              (click)="copyLink(link.value)"
              >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close i18n="Share post dialog|button @@sharePostDialog.cancelBtn">Отмена</button>
  @if (!data.post.shareCode) {
    <button style="margin-left: 16px" mat-flat-button color="primary" (click)="share(true)" [disabled]="loading"
      >
      <mat-icon>link</mat-icon>
      <ng-container i18n="Share post dialog|button @@sharePostDialog.shareBtn">Открыть доступ</ng-container>
    </button>
  }
  @if (data.post.shareCode) {
    <button style="margin-left: 16px" mat-flat-button color="primary" (click)="share(false)" [disabled]="loading"
      >
      <mat-icon>link_off</mat-icon>
      <ng-container i18n="Share post dialog|button @@sharePostDialog.unshareBtn">Закрыть доступ</ng-container>
    </button>
  }
</mat-dialog-actions>
